"use client";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import React, { Dispatch, FC, FormEvent, PropsWithChildren, SetStateAction, useState } from "react";
import { useRefresh } from "react-admin";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import axiosInstance from "@/utils/axiosInstance";
interface Props extends PropsWithChildren {
  title: string;
  description?: string;
  resource: string;
  data: unknown;
  responseMessage?: string;
  object?: unknown;
  setFormProp?: Dispatch<SetStateAction<unknown>>
}
const CommonCreate: FC<Props> = ({ title, description, resource, data, responseMessage, object, setFormProp, children }) => {
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const refresh = useRefresh()
    const submitForm = async (e: FormEvent) => {
        e.preventDefault()
        setLoading(true)
        try {
            await axiosInstance.post(`/${resource}`, data)
            toast(responseMessage || "Record created")
            refresh()
            if (object && setFormProp) setFormProp(object)
        } catch (err: any) {
            toast(err.response.data.message)
        } finally {
            setOpen(false)
            setLoading(false)
        }
    }
    
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <Plus className="h-4 w-4" />
        {title}
      </Button>
      <DialogContent
        className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto overflow-visible"
        onClick={(e) => e.stopPropagation()}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <form onSubmit={submitForm} className="py-4">
          {children}
          <DialogFooter className="relative z-[99] pointer-events-auto w-full mt-3">
            <Button id="submit-button" type="submit" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CommonCreate;
